export default __webpack_public_path__ + "static/media/IconTopicManagement.564b8d55.svg";